import PropTypes from 'prop-types';
import React, { useRef } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { AlertText } from 'ui';
import { severities } from '../utils/app-configs';
import Input from './input';

const StyledInput = styled(Input)`
  margin-top: 6px;
  ${p => p.error && 'border-color: red !important;'}
`;

const Required = styled.span`
  color: red;
`;

const MaxLengthInput = ({ name, max = 100, onChange, prefix = '', description, value = '' }) => {
  const charactersLeft = useRef(max);

  const onValueChanged = (e) => {
    charactersLeft.current = max - e.target.value.length;
    if (onChange) {
      onChange(e);
    }
  };

  const getValue = () => {
    if (!prefix) {
      return value;
    }
    if (!value.replace(prefix, '') || !value.includes(prefix)) {
      return prefix;
    }
    return `${prefix}${value.replace(prefix, '')}`;
  };

  return (
    <>
      {description ? <label><Required>* </Required>{description}</label> : null}
      <StyledInput
        name={name}
        onChange={onValueChanged}
        value={getValue()}
        error={charactersLeft?.current < 0}
        onKeyDown={e => e.keyCode === 13 ? e.preventDefault() : ''}
      />
      {charactersLeft?.current < 0 ?
        <AlertText type={severities.ERROR}>
          <FormattedMessage id='rules.DESCRIPTION_MAX_LENGTH' values={{ max }} />
        </AlertText> :
        null
      }
    </>
  );
};
MaxLengthInput.propTypes = {
  max: PropTypes.number,
  onChange: PropTypes.func,
  prefix: PropTypes.string,
  name: PropTypes.string,
  description: PropTypes.string,
  value: PropTypes.string,
};

export default MaxLengthInput;
